import { useCallback, useEffect } from "react";

const SEARCH_MAP_OFFSET = "--cwrr-search-map-offset";
const TOP_NAV_HEIGHT = 36;
const TOP_BANNER_HEIGHT = 60;
const TOP_SUB_NAV_HEIGHT = 84;

function getTopBannerHeight() {
  const topBanner = document.querySelector('.top-nav-projects__has-top-banner');

  return topBanner ? TOP_BANNER_HEIGHT : 0;
}

function calculateMapOffset() {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

  const TOP_BANNER_HEIGHT = getTopBannerHeight();

  if (scrollTop <= (TOP_NAV_HEIGHT + TOP_BANNER_HEIGHT)) {
    return TOP_SUB_NAV_HEIGHT + ((TOP_NAV_HEIGHT + TOP_BANNER_HEIGHT) - scrollTop);
  }

  return TOP_SUB_NAV_HEIGHT;
}

export function useMapSize(mapRef) {
  const map = mapRef?.current;

  const setOffset = useCallback(() => {
    const offset = calculateMapOffset();
    document.documentElement.style.setProperty(SEARCH_MAP_OFFSET, `${offset}px`);
  }, []);

  useEffect(() => {
    if (map) {
      setOffset();
    }
  }, [map, mapRef, setOffset]);

  useEffect(() => {
    window.addEventListener("scroll", setOffset);
    return () => {
      window.removeEventListener("scroll", setOffset);
    };
  }, [setOffset]);
}
